import React, { useState } from 'react';
import { CnIcon, CnMessage } from '@cainiaofe/cn-ui';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { oneLight } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import $i18n from '@alife/panda-i18n';
import './index.scss';
import classNames from 'classnames';

const CodeBlock = (props) => {
  const { language, children } = props;
  const [fold, setFold] = useState(false);

  return (
    <div>
      <div
        className={classNames('codeToolbar', { fold })}
        onClick={() => {
          setFold((cur) => !cur);
        }}
      >
        <div>{language}</div>
        <CopyToClipboard
          text={String(children)}
          onCopy={() => {
            CnMessage.success($i18n.get({ id: 'TERM.CopySuccessful', dm: '复制成功' }));
          }}
        >
          <div
            className="copyBtn"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <CnIcon type="copy" size={20} style={{ marginRight: 4 }} />
            <span>{$i18n.get({ id: 'TERM.Copy', dm: '复制' })}</span>
          </div>
        </CopyToClipboard>
      </div>
      {fold ? null : (
        <SyntaxHighlighter
          language={language}
          style={oneLight}
          showLineNumbers
          wrapLines
          linkTarget="_blank"
        >
          {String(children)}
        </SyntaxHighlighter>
      )}
    </div>
  );
};

export default CodeBlock;
